import { Box, Typography, Grid, Button, Tooltip } from '@mui/material';
import AvatarImage from '../../../common/avatar-image';
import ApproveDialog from '../approve-dialog';
import { useState } from 'react';
import { PendingActionCardProps } from '../../../common/utils/interfaces';
import { useMutation } from '@apollo/client';
import { EDIT_MEMBER_APPROVAL_REQUEST } from '../../gql';
import { ApprovalRequestType } from '../../../common/utils/enum';

function PendingActionCardTypeOne({
  id,
  description,
  resources,
  date,
  state
}: PendingActionCardProps): JSX.Element {
  const [open, setOpen] = useState(false);

  const handleClickOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const [editMemberApprovalRequest] = useMutation(EDIT_MEMBER_APPROVAL_REQUEST);
  const [cardStatus, setCardStatus] = useState<string>(state);
  const handleReject = async (): Promise<void> => {
    try {
      setCardStatus(ApprovalRequestType.REJECTED);
      await editMemberApprovalRequest({
        variables: {
          input: {
            id,
            action: 'REJECT',
            comment: ''
          }
        }
      });
    } catch (error) {
      setCardStatus(ApprovalRequestType.PENDING);
    }
  };
  return (
    <Box
      sx={{
        marginBottom: '16px',
        padding: '16px',
        borderRadius: '8px',
        border: '1px solid rgba(95, 99, 104, 0.5)'
      }}
    >
      <ApproveDialog
        id={id}
        open={open}
        comment=""
        handleClose={handleClose}
        setApprovelStatus={function (value: { status: string }): void {
          setCardStatus(value.status as unknown as ApprovalRequestType);
        }}
      />
      <Grid container spacing={2} sx={{ width: '100%', height: 'auto' }}>
        <Grid item xs={12} sm={8}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <Box
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                overflowWrap: 'break-word',
                wordBreak: 'break-word'
              }}
            >
              <Typography variant="body1">{description}</Typography>
            </Box>
            <Grid container spacing={2} sx={{ width: '100%', height: 'auto' }}>
              {resources?.map((resource) => (
                <Grid item xs={12} sm={6} md={4} xl={3} key={resource.id}>
                  <Tooltip title={resource.displayName} placement="top" arrow>
                    <Box sx={{ display: 'flex', gap: '12px' }}>
                      <AvatarImage
                        key={resource.id}
                        fontSize="16px"
                        providerId={resource.providerId}
                        alt={resource.displayName}
                      />
                    </Box>
                  </Tooltip>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Grid
            container
            spacing={'16px'}
            sx={{ width: '100%', height: '100%' }}
          >
            <Grid
              item
              xs={12}
              sx={{ display: 'flex', justifyContent: 'flex-end', gap: '16px' }}
            >
              {cardStatus === 'PENDING' ? (
                <>
                  <Button
                    onClick={() => {
                      void (async () => {
                        await handleReject();
                      })();
                    }}
                    sx={{
                      border: '1px solid var(--M3-sys-light-primary, #295DAB)',
                      borderRadius: '100px',
                      padding: '10px 24px',
                      textTransform: 'none',
                      height: '40px'
                    }}
                  >
                    Reject
                  </Button>
                  <Button
                    onClick={handleClickOpen}
                    sx={{
                      backgroundColor: 'rgba(226, 236, 246, 1)',
                      borderRadius: '100px',
                      padding: '10px 24px',
                      textTransform: 'none',
                      height: '40px'
                    }}
                  >
                    Approve
                  </Button>
                </>
              ) : (
                <Typography
                  variant="body1"
                  style={{
                    color:
                      cardStatus === 'APPROVED'
                        ? 'rgba(40, 164, 67, 1)'
                        : 'rgba(253, 0, 0, 1)'
                  }}
                >
                  {cardStatus === 'APPROVED' ? 'Approved' : 'Rejected'}
                </Typography>
              )}
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end'
              }}
            >
              <Typography
                sx={{
                  fontSize: '13px',
                  fontWeight: '400',
                  color: 'rgba(116, 119, 127, 1)',
                  width: 'auto',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  minWidth: '200px'
                }}
              >
                {new Date(date).toLocaleString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit'
                })}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default PendingActionCardTypeOne;
